"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var cache = {};

exports.default = {
	get: function get(key) {
		return cache[key];
	},
	set: function set(key, value) {
		cache[key] = value;
	},
	bust: function bust(key) {
		delete cache[key];
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/sipgate-rest-api-client/dist/promiseCache.js
// module id = 835
// module chunks = 0